import InputCity from "./InputCity";
import "../App.css";
export default function CityCard() {
  return <InputCity />;
}
